import { ResumeCard } from '@cp/entities/resume';
import { Skeleton } from '@cp/ds/src/components/skeleton';

export const ResumeCardFallback = () => (
  <ResumeCard
    footer={<Skeleton sx={{ margin: '10px' }} />}
    header={<Skeleton sx={{ width: '50%' }} />}
    profilePhoto={<Skeleton sx={{ minHeight: '350px' }} />}
    sx={{ backgroundColor: 'white', width: '100%' }}
  />
);
